// extracted by mini-css-extract-plugin
export default {"divider":"_3AljtyKdEzAto3hs3ZBnEb"};